import { MapPin, Clock, Phone } from "lucide-react";
import { BRAND, GALLERY } from "@/data/lakaData";

const Centro = () => (
  <section
    id="centro"
    data-testid="centro-section"
    className="py-24 md:py-32"
    style={{ background: "#E8DFD1" }}
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-5">
          <span className="laka-eyebrow">El centro</span>
          <h2 className="mt-4 font-serif-laka text-4xl md:text-5xl lg:text-[3.2rem] font-light leading-[1.05] text-[#1A1A1A]">
            Un espacio creado <span className="italic text-[#D6B36A]">para cuidarte</span>
          </h2>
          <p className="mt-6 text-sm md:text-base text-[#1A1A1A]/70 leading-relaxed font-light">
            Estamos en <strong className="text-[#1A1A1A] font-medium">Eduardo Criado nº20</strong>,
            local comercial, CP 23740, Andújar, Jaén. Un centro diseñado para que
            cada visita sea íntima, cómoda y especial.
          </p>

          <div className="mt-8 space-y-4">
            <div className="flex items-start gap-3">
              <MapPin
                className="w-4 h-4 text-[#D6B36A] mt-1 shrink-0"
                strokeWidth={1.5}
              />
              <div>
                <div className="text-[0.62rem] tracking-[0.3em] uppercase text-[#1A1A1A]/50 mb-1">
                  Dirección
                </div>
                <div className="text-sm text-[#1A1A1A]">{BRAND.address}</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Clock
                className="w-4 h-4 text-[#D6B36A] mt-1 shrink-0"
                strokeWidth={1.5}
              />
              <div>
                <div className="text-[0.62rem] tracking-[0.3em] uppercase text-[#1A1A1A]/50 mb-1">
                  Horario
                </div>
                <div className="text-sm text-[#1A1A1A]">
                  Lunes a Sábado · Cita previa recomendada
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Phone
                className="w-4 h-4 text-[#D6B36A] mt-1 shrink-0"
                strokeWidth={1.5}
              />
              <div>
                <div className="text-[0.62rem] tracking-[0.3em] uppercase text-[#1A1A1A]/50 mb-1">
                  Teléfono
                </div>
                <a
                  href={BRAND.phoneHref}
                  className="text-sm text-[#1A1A1A] hover:text-[#D6B36A] transition-colors"
                >
                  {BRAND.phone}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-3 gap-3 mb-4">
            {GALLERY.map((g, i) => (
              <div
                key={g.label}
                data-testid={`centro-gallery-${i}`}
                className="relative overflow-hidden group"
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  className="w-full h-40 md:h-56 object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1A1A1A]/70 to-transparent p-3">
                  <span className="text-[0.6rem] tracking-[0.28em] uppercase text-[#FBF6F2] font-medium">
                    {g.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div className="border border-[#D6B36A]/30 overflow-hidden">
            <iframe
              data-testid="centro-map"
              title="LAKA CLUB BEAUTY - Ubicación"
              src="https://www.google.com/maps?q=Eduardo+Criado+20,+23740+And%C3%BAjar,+Ja%C3%A9n,+Spain&output=embed"
              width="100%"
              height="320"
              style={{ border: 0, filter: "grayscale(0.15) contrast(0.95)" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Centro;
